import { memo, useState } from "react";
import { DialogModal, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import CreditNoteVesselContent from "./CreditNoteVesselContent";
import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import { useCreditNoteDetailVesselVM } from "presentation/hook/CreditNote/useCreditNoteDetailVesselVM";
import { CreditNoteConstant } from "presentation/constant/CreditNote/CreditNoteConstant";

const CreditNoteVesselComp: React.FC = () => {
    const [creditNoteDetailState] = useCreditNoteDetailTracked();
    const creditNoteDetailVesselVM = useCreditNoteDetailVesselVM();
    const { isShowFindVesselPanel } = creditNoteDetailState;
    const [isLoading,] = useState(false);

    const handleCloseDialog = () => {
        creditNoteDetailVesselVM.closeCntrCompDialog();
    }

    if (isLoading) return <Loader Indicator="Spinner" size="Medium" />;

    return <DialogModal style={{ minWidth: '62vw', minHeight: '80vh' }}
        appendTo='self'
        showButton={false}
        visible={isShowFindVesselPanel}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">{CreditNoteConstant.Detail.CO_VSL_VOY}</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={handleCloseDialog} tooltipDisable={true} />
            </div>
        }
        dialogContent={<CreditNoteVesselContent />}
        className="im-charge-data-search-confirm-modal"
    />
}

export default memo(CreditNoteVesselComp);